import { render, staticRenderFns } from "./SupplierContract.vue?vue&type=template&id=12974f59"
import script from "./SupplierContract.vue?vue&type=script&lang=js"
export * from "./SupplierContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports